module.exports = __webpack_public_path__ + "img/logo-2x.81dc3200.png";